"use client";

import React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BioCertifiedLabStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const certifications = [{
    name: "Oxford University",
    img: "/img/oxford_university_logo.png"
  }, {
    name: "University of Toronto",
    img: "/img/toronto_university_logo.png"
  }, {
    name: "Harvard University",
    img: "/img/harvard_university_logo.png"
  }, {
    name: "University of Melbourne",
    img: "/img/melbourne_university_logo.png"
  }, {
    name: "UBC Canada",
    img: "/img/ubc_university_logo.png"
  }];
  return <section data-section-id="37933" id="institutional-partners" className="bg-background text-foreground py-12 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("flex flex-col md:flex-row items-stretch rounded-sm overflow-hidden border border-border/60 bg-muted/30 backdrop-blur-sm transition-all duration-1000 ease-out transform shadow-sm", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {}
          <div className="bg-muted/50 md:w-16 py-3 md:py-0 flex items-center justify-center border-b md:border-b-0 md:border-r border-border/60 shrink-0">
            <span className="text-[10px] md:text-xs font-default font-semibold tracking-[0.25em] text-primary md:[writing-mode:vertical-rl] md:rotate-180 uppercase whitespace-nowrap">
              Trust by Global Institutions
            </span>
          </div>

          {}
          <div className="flex-1 flex flex-wrap md:flex-nowrap items-center justify-around gap-8 p-6 md:px-12 md:py-10">
            {certifications.map((cert, i) => <div key={i} data-index={i} className="group relative flex items-center justify-center">
                <img src={cert.img} alt={cert.name} className="h-8 md:h-12 w-auto object-contain opacity-40 grayscale transition-all duration-500 group-hover:opacity-100 group-hover:grayscale-0 filter" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}